import { MetricRequest } from "../Client/MetricRequest"
import { MetricQualityObject, isQualityValue } from "../DataProgram/Measurement"

export type MetricField = "fields" | "choices"

export interface MetricFields {
    [key: string]: { [key in MetricField]?: string[] }
}

export interface APIAppMetricModel {
    workflow: string
    apiId: string
    id: number
    quality: MetricQualityObject
    cost: number
    latency: number
    created: number
}

export interface APIAppInstanceMetricModel {
    id: number
    uuid: string
    created: string
    updated: string
    app_id: string
    app_template: string
    metric_name: string
    active: boolean
    fields?: { [key in MetricField]?: string[] }
}

export function toMetricRequest(metric: APIAppMetricModel): MetricRequest {
    return {
        workflow: metric.workflow,
        cost: metric.cost,
        latency: metric.latency,
        quality: Object.entries(metric.quality).reduce(
            (passed, [key, value]) =>
                isQualityValue(value) ? { ...passed, [key]: value } : passed,
            {}
        )
    }
}
